import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { environment } from '@y42/environment';
import { AbstractGitEntityStore } from '@y42/feature/git/state';
import { VisualizationTabGitFactoryService } from './visualization-tab-git-factory.service';
import type { VisualizationTabState } from './visualization-tab.model';

const initialState: VisualizationTabState = {
  loading: true,
  active: null,
  ui: {
    editMode: !environment.production_build,
    sidebar: {
      open: false,
      type: 'theme',
    },
  },
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'visualization-tab', idKey: '$path' })
export class VisualizationTabStore extends AbstractGitEntityStore<VisualizationTabState> {
  constructor(protected readonly gitFactory: VisualizationTabGitFactoryService) {
    super({
      name: 'Visualization-Tab',
      initialState,
      gitFactory,
    });
  }
}
